import { PageLayout } from "components";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import DataObject from "containers/DataObject";
import UserBusinessAreaSchemaWrapper from "containers/UserBusinessAreaSchemaWrapper";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

function usePreviousAction(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const DataObjectPage = (props) => {
    const { tenant, businessarea, schema, dataset, dataObjectId, dataObjectAction } = useParams();
    const prevDataObjectAction = usePreviousAction(dataObjectAction);

    return (
        <PageLayout
            key={`${businessarea}_${schema}_${dataset}_dataobjects_page`}
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <SegmentContainer>
                        <Segment shadow space="sm">
                            <UserBusinessAreaSchemaWrapper key={`${businessarea}_${schema}_wrapper`} tenant={tenant} businessArea={businessarea.toLowerCase()} schema={schema}>
                                {(childProps) => (
                                    <DataObject
                                        key={`${businessarea}_${schema}_${dataset}_${dataObjectAction || "default"}_dataobjects`}
                                        setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                                        tenant={tenant}
                                        businessArea={businessarea.toLowerCase()}
                                        schema={schema}
                                        dataset={dataset}
                                        action={dataObjectAction}
                                        prevAction={prevDataObjectAction}
                                        dataObjectId={dataObjectId}
                                        {...childProps}
                                    ></DataObject>
                                )}
                            </UserBusinessAreaSchemaWrapper>
                        </Segment>
                    </SegmentContainer>
                );
            }}
        ></PageLayout>
    );
};

export default DataObjectPage;
